// prefer default export if available
const preferDefault = m => m && m.default || m

exports.components = {
  "component---src-templates-page-feed-js": () => import("/opt/render/project/src/src/templates/page-feed.js" /* webpackChunkName: "component---src-templates-page-feed-js" */),
  "component---src-templates-page-js": () => import("/opt/render/project/src/src/templates/page.js" /* webpackChunkName: "component---src-templates-page-js" */),
  "component---src-templates-post-js": () => import("/opt/render/project/src/src/templates/post.js" /* webpackChunkName: "component---src-templates-post-js" */)
}

